<template>
  <div class="main-container">
    <!-- Navigation -->
    <div
      class="sidebar-widget"
      :class="{
        minimized: $store.state.side_bar,
        phone_minimized: phone_menu_minimized,
      }"
      ref="sidebar_widget"
      v-closable="{ exclude: ['sidebar_widget'], handler: 'hideAllDropDown' }"
    >
      <div class="profile-widget">
        <div class="btn-menu-logo">
          <button
            class="btn-menu"
            @click="$store.state.side_bar = !$store.state.side_bar"
          >
            <img src="@/assets/admin-icon/admin-menu.svg" />
          </button>
          <img
            class="profile-logo"
            v-if="$getLoggedUser().manager_picture"
            :src="
              $fullUrl('images/profiles/' + $getLoggedUser().manager_picture)
            "
          />
          <img class="profile-logo" v-else src="@/assets/avatar.png" />
        </div>
        <h5>{{ $getLoggedUser().manager_name | validate }}</h5>
        <p v-if="false">Senior Consultant, partner styrelseledamot</p>
      </div>
      <div
        class="menu-list"
        :class="{ 'on-dropdown-menu-open': on_dropdown_menu_open }"
      >
        <ul>
          <li
            class="item"
            v-for="(item, index) in routes"
            :key="index"
            :class="{
              active:
                $route.name == item.name ||
                whenRouterEqual(item.name) ||
                item.dropdown_active,
              wizard_active: $store.state.wizard_active_menu == item.name,
            }"
          >
            <div class="link" @click="navigateTo(item)">
              <img
                width="20"
                :src="require('@/assets/admin-icon/' + item.icon)"
              />
              <span class="text-dropdown">
                <span class="text">{{ item.label | validate }}</span>
                <div class="drop-icon" v-if="item.dropdown">
                  <img
                    width="11"
                    v-if="item.dropdown_active"
                    src="@/assets/admin-icon/dropdown_active.svg"
                  />
                  <img
                    v-else
                    width="7"
                    src="@/assets/admin-icon/dropdown_nonactive.svg"
                  />
                </div>
              </span>
            </div>
            <div class="dropdown" v-if="item.dropdown_active && item.dropdown">
              <div
                class="dropdown-link"
                v-for="(val, index) in item.dropdown"
                :key="index"
                :class="{
                  active:
                    $route.name == item.name && $route.params.type == val.name,
                }"
                @click="navigateDropDownTo(item, val)"
              >
                {{ val.label | validate }}
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="body-container"
      :class="{
        minimized: $store.state.side_bar,
        phone_minimized: phone_menu_minimized,
      }"
    >
      <div v-show="getLoader.isLoading" class="loading-container">
        <loading></loading>
      </div>
      <router-view>
        <slot> </slot>
      </router-view>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/Loader/Loading";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["getLoader"]),
  },
  mounted() {
    let vm = this;
    window.addEventListener("message", (event) => {
      const message = event.data.message;
      switch (message) {
        case "toggleNavigation":
          vm.toggleNavigation();
          break;
      }
    });
  },
  data: () => ({
    show_settinds_dropdown: false,
    phone_menu_minimized: true,
    routes: [
      {
        name: "search",
        label: "Search",
        icon: "search.svg",
        dropdown_active: false,
        dropdown: null,
      },
      {
        name: "dashboard",
        label: "Dashboard",
        icon: "home.svg",
        dropdown_active: false,
        dropdown: null,
      },
      {
        name: "task",
        label: "Task",
        icon: "task.svg",
        dropdown_active: false,
      },
      {
        name: "leads",
        label: "Leads",
        icon: "leads.svg",
        dropdown_active: false,
        dropdown: null,
      },
      {
        name: "candidates",
        label: "Candidates",
        icon: "candidate.svg",
        dropdown_active: false,
        dropdown: null,
      },
      {
        name: "accounts",
        label: "Accounts",
        icon: "customers.svg",
        dropdown_active: false,
      },
      {
        name: "organization",
        label: "Organization",
        icon: "organization.svg",
        dropdown_active: false,
      },
      {
        name: "assignment",
        label: "Assignment",
        icon: "assignment.svg",
        dropdown_active: false,
      },
      {
        name: "resumes",
        label: "Resumes",
        icon: "resumes.svg",
        dropdown_active: false,
      },
      {
        name: "pitch",
        label: "Pitches",
        icon: "pitch.svg",
        dropdown_active: false,
      },
      {
        name: "reports",
        label: "Reports",
        icon: "reports.svg",
        dropdown_active: false,
        dropdown: null,
      },
    ],
    on_dropdown_menu_open: false,
  }),
  watch: {},
  methods: {
    toggleNavigation() {
      let vm = this;
      vm.phone_menu_minimized = !vm.phone_menu_minimized;
    },
    hideAllDropDown() {
      let vm = this;

      if (vm.$store.state.side_bar) {
        vm.routes.map((item) => {
          item.dropdown_active = false;
        });
      }
    },
    navigateDropDownTo(item, val) {
      let vm = this;
      vm.$router
        .push({ name: item.name, params: { type: val.name } })
        .catch((error) => {});
      if (vm.$store.state.side_bar) {
        item.dropdown_active = false;
        vm.on_dropdown_menu_open = false;
      } else {
        item.dropdown_active = true;
      }
    },
    navigateTo(item) {
      let vm = this;
      vm.phone_menu_minimized = true;
      if (item.dropdown) {
        if (!item.dropdown_active) {
          vm.routes.map((item) => {
            item.dropdown_active = false;
          });
          item.dropdown_active = true;
          vm.on_dropdown_menu_open = true;
        } else {
          item.dropdown_active = false;
          vm.on_dropdown_menu_open = false;
        }
      } else {
        vm.routes.map((item) => {
          item.dropdown_active = false;
        });
        vm.$router.push({ name: item.name }).catch((error) => {});
      }
    },
    hideMenu() {
      let vm = this;
      vm.show_settinds_dropdown = false;
    },
    logOut() {
      let vm = this;
      vm.$store.dispatch("AUTH_LOGOUT");
      vm.$localStorage.remove("logged_user_data");
      vm.$router.push({ name: "login" });
    },
    whenRouterEqual(label) {
      let vm = this;
      if (label == "organization") {
        if (vm.$route.name == "manage_consultant") {
          return true;
        }
        if (vm.$route.name == "view-team") {
          return true;
        }
      } else if (label == "accounts") {
        if (vm.$route.name == "account-view") {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss">
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.main-container {
  .sidebar-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 172px;
    background: linear-gradient(
      186deg,
      rgba(27, 165, 164, 1) 0%,
      rgba(24, 133, 173, 1) 100%
    );
    z-index: 9999999999;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    transition: 600ms ease-in-out;
    @media (min-width: 300px) and (max-width: 650px) {
      right: 0px;
      left: unset;
    }
    &.minimized {
      padding-top: 20px;
      width: 60px;
      z-index: 9999999999999 !important;
      transition: 600ms ease-in-out;
      * {
        transition: 600ms ease-in-out;
      }
      .profile-widget {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100px;
        padding-top: 6px;
        @media (min-width: 300px) and (max-width: 650px) {
          display: none;
        }
        .btn-menu-logo {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          position: relative;
          .btn-menu {
            background: transparent;
            border: none;
            position: unset;
            left: unset;
            margin-bottom: 14px;
          }
          .profile-logo {
            width: 30px;
            height: 30px;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        h5 {
          margin-bottom: 0px;
          margin-top: 6px;
          font-size: 18px;
          color: #fff;
          display: none;
        }
        p {
          margin-top: 2px;
          margin-bottom: 0px;
          width: 200px;
          text-align: center;
          color: #ddd;
          display: none;
        }
      }
      .menu-list {
        height: calc(100% - 55px);
        overflow-y: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
          display: none;
        }
        &.on-dropdown-menu-open {
          overflow-y: unset;
        }
        ul {
          list-style: none;
          padding-left: 0px;
          li.item {
            padding: 2px 0px;
            display: flex;
            flex-direction: column;
            cursor: pointer;
            position: relative;
            &.wizard_active {
              animation: blinker 1s linear infinite;
            }

            .link {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 15px 15px;
              img.icon {
                margin-right: 30px;
                width: 16px;
              }
              .text-dropdown {
                span.text {
                  color: #fff;
                  font-size: 13px;
                  width: 85%;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  display: none;
                }
                .drop-icon {
                  margin-left: 5px;
                  margin-top: 2px;
                }
              }
            }
            .dropdown {
              display: flex;
              flex-direction: column;
              margin-top: 10px;
              position: absolute;
              z-index: 99999999999999999999999999999;
              background: #147489;
              left: 60px;
              width: 200px;
              .dropdown-link {
                padding: 15px 0px;
                color: #fff;
                padding-left: 15px !important;
                &.active {
                  background: #1a9fa5;
                  color: #fff;
                }
                &:hover {
                  background: #1a9fa5;
                  color: #fff;
                }
              }
            }

            &.active {
              background: #1a9fa5;
              span {
                color: #fff;
              }
            }
            &:hover {
              background: #1a9fa5;
              span {
                color: #fff;
              }
            }
          }
          li.divider {
            border-bottom: 1px solid #1aa9b9;
          }
        }
      }
    }
    &.phone_minimized {
      @media (min-width: 300px) and (max-width: 650px) {
        right: -182px;
      }
    }
    .profile-widget {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 125px;
      @media (min-width: 300px) and (max-width: 650px) {
        display: none;
      }
      .btn-menu-logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        .btn-menu {
          background: transparent;
          border: none;
          position: absolute;
          left: -54px;
        }
        .profile-logo {
          width: 50px;
          height: 50px;
          object-fit: cover;
          border-radius: 50%;
        }
      }
      h5 {
        margin-bottom: 0px;
        margin-top: 6px;
        font-size: 18px;
        color: #fff;
      }
      p {
        margin-top: 2px;
        margin-bottom: 0px;
        width: 200px;
        text-align: center;
        color: #ddd;
      }
    }
    .menu-list {
      height: calc(100% - 125px);
      overflow-y: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      @media (min-width: 300px) and (max-width: 650px) {
        height: calc(100% - 0px);
      }
      ul {
        list-style: none;
        padding-left: 0px;
        li.item {
          padding: 2px 0px;
          display: flex;
          flex-direction: column;
          cursor: pointer;
          &.wizard_active {
            animation: blinker 1s linear infinite;
          }
          .link {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 15px 15px;
            img.icon {
              margin-right: 30px;
              width: 16px;
            }
            .text-dropdown {
              width: 76%;
              display: flex;
              align-items: center;
              span.text {
                color: #fff;
                font-size: 13px;
                width: 85%;
                display: flex;
                align-items: center;
                justify-content: space-between;
              }
              .drop-icon {
                margin-left: 5px;
                margin-top: 2px;
              }
            }
          }
          .dropdown {
            display: flex;
            flex-direction: column;
            margin-top: 10px;
            background: #147489;
            .dropdown-link {
              padding: 15px 0px;
              color: #fff;
              padding-left: 48px !important;
              &.active {
                color: #0884af;
                background: #fff;
              }
              &:hover {
                color: #0884af;
                background: #fff;
              }
            }
          }
          &.active {
            background: #1a9fa5;
            span {
              color: #fff;
            }
          }
          &:hover {
            background: #1a9fa5;
            span {
              color: #fff;
            }
          }
        }
        li.divider {
          border-bottom: 1px solid #1aa9b9;
        }
      }
    }
  }
  .body-container {
    position: fixed;
    left: 172px;
    right: 0px;
    bottom: 0px;
    top: 5px;
    display: flex;
    flex-direction: column;
    z-index: 999999995;
    transition: 600ms ease-in-out;
    @media (min-width: 300px) and (max-width: 650px) {
      left: 0px;
    }
    .loading-container {
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      z-index: 9999999999;
      background: rgba($color: #fff, $alpha: 1);
    }
    &.minimized {
      left: 60px;
      transition: 600ms ease-in-out;
    }
    &.phone_minimized {
      @media (min-width: 300px) and (max-width: 650px) {
        left: 0px;
      }
    }
  }
}
</style>
